import React, { useState } from "react";

import "./Recycling.css";

import Carousel from "./Carousel";

import DescriptionCarton from "../../assets/images/square_carton_title.jpg";
import DescriptionMetaux from "../../assets/images/square_metaux_title.jpg";
import DescriptionPlastique from "../../assets/images/square_plastique_title.jpg";
import DescriptionVerre from "../../assets/images/square_verre_title.jpg";
import DescriptionAutre from "../../assets/images/square_autre_title.jpg";

import LogoAlu from "../../assets/images/alu-2.png";
import LogoAluTriangle from "../../assets/images/logo-alu-recycle-triangle.png";
import LogoMorbius from "../../assets/images/morbius.png";
import LogoTriman from "../../assets/images/triman-logo.jpg";

const Recycling = () => {
  const [infoChoice, setInfoChoice] = useState();

  const infoList = [
    {
      id: 1,
      title: "Plastique",
      info: "Il existe différents types de plastiques. Tous les emballages plastiques alimentaires et d'entretien sont recyclables.",
      list: [
        "blisters",
        "sachets",
        "film alimentaire",
        "barquettes",
        "bouteille",
        "pot de yaourt",
      ],
      binImage: DescriptionPlastique,
      imageRecycling: [LogoTriman],
    },
    {
      id: 2,
      title: "Carton/Papier",
      info: "Le carton et le papier sont totalement recyclables.",
      list: ["carton", "journal", "papier", "brique de lait", "gobelet"],
      binImage: DescriptionCarton,
      imageRecycling: [LogoTriman, LogoMorbius],
    },
    {
      id: 3,
      title: "Métaux",
      info: "Les emballages en métal sont recyclables.",
      list: ["conserves", "canettes", "boite de gâteaux", "couvercle"],
      binImage: DescriptionMetaux,
      imageRecycling: [LogoTriman, LogoAlu, LogoAluTriangle],
    },
    {
      id: 4,
      title: "Verre",
      info: "Le verre est recyclable à l'exception de la vaisselle en verre.",
      list: ["bouteilles", "pots", "bocaux"],
      binImage: DescriptionVerre,
      imageRecycling: [LogoTriman],
    },
    {
      id: 5,
      title: "Autre",
      info: "Les restes alimentaires, les dosettes à café, les articles d'hygiène (coton, couches, essuie tout, masque ...), vaisselle en porcelaine ou jetable, pots en terre cuite ne sont pas recyclables.",
      list: [],
      binImage: DescriptionAutre,
      imageRecycling: [],
    },
  ];

  console.log(infoList);

  const handleInfoChoice = (infoChoice) => {
    setInfoChoice(infoChoice);
  };

  return (
    <div className="RecyclingPage">
      <div className="background-decoration1"></div>
      <div className="background-decoration2"></div>
      <div className="background-decoration3"></div>

      <div className="RecyclingPage-desktop">
        <h2>Informations sur le recyclage</h2>
        <h4>Comment savoir si mon emballage est recyclable ?</h4>

        <div className="top-recycling-buttons">
          <button
            className={`btn ${
              infoChoice === 1 ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => handleInfoChoice(1)}
          >
            Plastique
          </button>
          <button
            className={`btn ${
              infoChoice === 2 ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => handleInfoChoice(2)}
          >
            Carton/Papier
          </button>
          <button
            className={`btn ${
              infoChoice === 3 ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => handleInfoChoice(3)}
          >
            Métaux
          </button>
          <button
            className={`btn ${
              infoChoice === 4 ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => handleInfoChoice(4)}
          >
            Verre
          </button>
          <button
            className={`btn ${
              infoChoice === 5 ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => handleInfoChoice(5)}
          >
            Autre
          </button>
        </div>

        <div className="info-recycling-container">
          {infoChoice && (
            <>
              <div className="left-info-recycling-container">
                <h3>{infoList[infoChoice - 1].title}</h3>
                <div className="left-info-recycling-image-container">
                  {infoList[infoChoice - 1].imageRecycling.map((element) => (
                    <img src={element} alt="illustration recycling" />
                  ))}
                </div>
                <p>{infoList[infoChoice - 1].info}</p>
                {infoList[infoChoice - 1].list && (
                  <>
                    <p>
                      Liste non exhaustive des produits :<br />
                      <ul className="left-info-recycling-list">
                        {infoList[infoChoice - 1].list.map((listU) => (
                          <li>{listU}</li>
                        ))}
                      </ul>
                    </p>
                  </>
                )}
                <a
                  href="https://www.triercestdonner.fr/guide-du-tri"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <button className="btn btn-outline-success">
                    Guide de tri officiel
                  </button>
                </a>
              </div>

              <div className="right-info-recycling-container">
                {infoChoice && (
                  <div className="right-info-recycling-image-container">
                    <img
                      src={infoList[infoChoice - 1].binImage}
                      alt="illustration recycling"
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      <div className="RecyclingPage-mobile">
        <h2>Informations sur le recyclage</h2>
        <h4>Comment savoir si mon emballage est recyclable ?</h4>

        <Carousel data={infoList} choice={setInfoChoice} />

        <div className="info-recycling-container">
          {infoChoice && (
            <>
              <div className="top-info-recycling-container">
                <h3>{infoList[infoChoice - 1].title}</h3>
                <div className="top-info-recycling-image-container">
                  {infoList[infoChoice - 1].imageRecycling.map((element) => (
                    <img src={element} alt="illustration recycling" />
                  ))}
                </div>
                <p>{infoList[infoChoice - 1].info}</p>
                {infoList[infoChoice - 1].list && (
                  <>
                    <p>
                      Liste non exhaustive des produits :<br />
                      <ul className="top-inf-recycling-list">
                        {infoList[infoChoice - 1].list.map((listU) => (
                          <li>{listU}</li>
                        ))}
                      </ul>
                    </p>
                  </>
                )}
                <a
                  href="https://www.triercestdonner.fr/guide-du-tri"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <button className="btn btn-outline-success">
                    Guide de tri officiel
                  </button>
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Recycling;
